/* platform.js — runtime platform detection for native vs web.
 *
 * Capacitor exposes `window.Capacitor.isNativePlatform()` once the bridge
 * loads. On web (Safari, Chrome) this is undefined. We use it to switch
 * between web download (a.download) and native (Filesystem + Share),
 * between WebAuthn API and native passkey plugin, etc.
 *
 * `getNativePlatform()` returns "ios" | "android" | null. */
export function isNative() {
  if (typeof window === "undefined") return false;
  return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
}

export function getNativePlatform() {
  if (!isNative()) return null;
  return window.Capacitor?.getPlatform?.() || null;
}

export function isIOSNative() {
  return getNativePlatform() === "ios";
}

export function isAndroidNative() {
  return getNativePlatform() === "android";
}
